import { Injectable } from '@angular/core';
import { SocialLogin } from '@capgo/capacitor-social-login';
import config from 'capacitor.config';

@Injectable({
  providedIn: 'root',
})
export class AppleAuthService {
  async signInWithApple() {
    return SocialLogin.login({
      provider: 'apple',
      options: {
        scopes: ['email', 'name'],
      },
    });
  }

  async initialize() {
    return SocialLogin.initialize({
      apple: {
        clientId: config.plugins.SocialLogin.apple.clientId,
        useProperTokenExchange: true,
      },
    });
  }
}
